/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { getLightElement } from '@tylertech/forge-core';
import { BaseAdapter } from '../../core/base/base-adapter';
import { MENU_CONSTANTS } from '../../menu';
export class AppBarHelpButtonAdapter extends BaseAdapter {
    constructor(component) {
        super(component);
    }
    initialize() {
        this._menuElement = getLightElement(this._component, MENU_CONSTANTS.elementName);
    }
    setMenuOptions(options) {
        this._menuElement.options = options;
    }
}
